import Domain from "./domain";
export default {
  methods: {
    listServers: async function () {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "microservice/list",
          Domain.APP_HEADER
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
    setupServer: async function (serverName, port) {
      try {
        if (!serverName || serverName === "") {
          throw Error("Server name an not be empty.");
        }
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "microservice/setup",
          {
            name: serverName,
            port: port
          },
          Domain.APP_HEADER
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
    setupServerStream: async function (serverName, responseCallback, errorCallback) {
      try {
        const headers = Domain.APP_HEADER.headers;
        const eventSource = new EventSource(Domain.APP_DOMAIN + `microservice/setup/stream?name=${serverName}`, headers);

        eventSource.onmessage = function (event) {
          try {
            const res = JSON.parse(event.data);
            const { type } = res;
            if (type === 'done') {
              responseCallback(res);
              eventSource.close();
            } else {
              responseCallback(res);
            }
          } catch (error) {
            responseCallback({ type: "error", "data": error.name == "SyntaxError" ? event.data : error.message });
            eventSource.close();
          }
        };

        eventSource.onerror = function (event) {
          errorCallback({ type: "error", data: event.data || event.error });
          eventSource.close();
        };

        eventSource.onopen = function (event) {
          responseCallback({ type: "info", data: "connection started" });
        };
      } catch (error) {
        errorCallback({type: "error", "message": error.message });
        eventSource.close();
      }
    },
    backupServers: async function () {
      try {
        let response = await this.axios.get(
          Domain.APP_DOMAIN + "microservice/backup",
          Domain.APP_HEADER
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
    triggerDeployPipeline: async function (ref, servers, target) {
      try {
        let response = await this.axios.post(
          Domain.APP_DOMAIN + "microservice/pipeline/trigger",
          {
            ref,
            servers,
            target
          },
          Domain.APP_HEADER
        );
        return response;
      } catch (error) {
        throw error;
      }
    },
    streamBackupServers: async function (responseCallback, errorCallback) {
      try {
        const eventSource = new EventSource(Domain.APP_DOMAIN + "microservice/backup/stream", {
          headers: Domain.APP_HEADER
        });

        eventSource.onmessage = function (event) {
          try {
            const data = JSON.parse(event.data);
            responseCallback(data);
          } catch (error) {
            if (error.name == "SyntaxError") {
              responseCallback({ "message": event.data });
            } else {
              responseCallback({ "message": error.message });
            }
          }
        };

        eventSource.onerror = function (event) {
          errorCallback({ data: event.data || event.error });
          eventSource.close();
        };

        eventSource.onopen = function (event) {
          responseCallback({ data: "connection started" });
        };
      } catch (error) {
        errorCallback({ "message": error.message });
      }
    }
  }
};
